import Accordion from '@/common/components/Accordion'
import { MaintenanceForwardingsDirectiveFormStepState } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { useEffect, useState } from 'react'

interface CreateForwardingDirectiveEntryFormStepAccordionProps {
  state: MaintenanceForwardingsDirectiveFormStepState
  title: string
  body: JSX.Element
}

const CreateForwardingDirectiveEntryFormStepAccordion = ({
  state,
  title,
  body,
}: CreateForwardingDirectiveEntryFormStepAccordionProps) => {
  const [open, setOpen] = useState(state === 'current')

  useEffect(() => {
    setOpen(state === 'current')
  }, [state])

  return (
    <Accordion
      open={open}
      defaultOpen={open}
      onToggle={setOpen}
      triggerDisabled={state === 'pending'}
      className="p-0"
      triggerClassName="p-4"
      bodyClassName="px-4 pb-4"
      head={title}
      body={body}
    />
  )
}

export default CreateForwardingDirectiveEntryFormStepAccordion
